<template>
  <button :class="['btn', 'station-controlpanel-button', highlight ? 'highlight' : '', sizeClass]" @click.prevent="$emit('click', $event);" :disabled="disabled"><i :class="[iconStyle, icon]" /> <slot /></button>
</template>

<style scoped>
.station-controlpanel-button {
  width: 52px;
  height: 46px;
  padding: 0;
  margin-right: 0.5rem;
  font-size: 11px;
  text-transform: uppercase;
}
.station-controlpanel-button.wide {
  width: 76px;
}
.station-controlpanel-button.lg {
  width: 60px;
  height: 52px;
}
.station-controlpanel-button.wide-lg {
  width: 76px;
  height: 52px;
}
.station-controlpanel-button.xl {
  width: 92px;
  height: 52px;
}
.station-controlpanel-button.btn-block {
  width: 100% !important;
}
.station-controlpanel-button.btn-success.highlight {
  border-width: 2px;
  border-color: #74CBFC !important;
}
.station-controlpanel-button > i {
  font-size: 1.2rem;
  display: block;
  padding: 4px 0px 5px 0px;
}
.station-controlpanel-button.lg > i {
  font-size: 1.3rem;
}

@media (max-width: 1399.98px) {
  .station-controlpanel-button {
    width: 40px !important;
    height: 46px !important;
    font-size: 9px;
  }
  .station-controlpanel-button > i {
    font-size: 1.0rem !important;
  }
}

.popper-popover .station-controlpanel-button.btn-default {
  background-color: #404040;
  border-color: #606060;
}
</style>

<script>
export default {
  name: 'StationControlPanelButton',
  props: {
    highlight: {
      type: Boolean,
      default: false
    },
    iconStyle: {
      type: String,
      default: 'far'
    },
    icon: String,
    sizeClass: String,
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>